import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/platform/components/AuthShell";
import { Button, GoogleButton, TextField, Divider } from "@/platform/components/primitives";
import { api } from "@/platform/api";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogle = () => {
  const redirectUrl = window.location.origin + "/app";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!EMAIL_RE.test(email.trim())) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/api/auth/signup/email", { email: email.trim() });
      sessionStorage.setItem("pinlayr.signup.email", res.email || email.trim());
      if (res.dev_code) sessionStorage.setItem("pinlayr.signup.devcode", res.dev_code);
      navigate("/verify");
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell
      altAction={{ label: "Already have an account?", to: "/login", cta: "Sign in" }}
      footer={
        <span>
          Already have an account?{" "}
          <a href="/login" className="font-semibold text-[#F4F5F8] hover:underline">Sign in</a>
        </span>
      }
    >
      <div className="animate-in fade-in duration-500">
        <h1 className="text-[26px] font-semibold tracking-tight text-[#F4F5F8]">Create your account</h1>
        <p className="mt-2 text-[15px] text-[#98A0B0]">Review websites directly where the work happens.</p>

        <div className="mt-8 space-y-3">
          <GoogleButton onClick={() => { setGoogleLoading(true); startGoogle(); }} loading={googleLoading} />
        </div>

        <div className="my-5"><Divider /></div>

        <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
          <TextField
            id="email"
            label="Email"
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={error}
            autoFocus
            data-testid="signup-email"
          />
          <Button type="submit" loading={loading} data-testid="signup-submit">Continue with email</Button>
        </form>

        <p className="mt-6 text-[12.5px] leading-relaxed text-[#6E7686]">
          By continuing, you agree to Pinlayr’s{" "}
          <a href="/terms" className="underline hover:text-[#AAB1BF]">Terms of Service</a> and{" "}
          <a href="/privacy" className="underline hover:text-[#AAB1BF]">Privacy Policy</a>.
        </p>
      </div>
    </AuthShell>
  );
}
